// FAKE DATA
export const books = [
  {
    id: 1,
    title: "Crack the Coding Interview",
    url: "https://m.media-amazon.com/images/I/61mIq2iJUXL._AC_UF1000,1000_QL80_.jpg",
    originalPrice: 49.95,
    salePrice: 14.95,
    rating: 4.5,
  },
  {
    id: 2,
    title: "Atomic Habits",
    url: "https://m.media-amazon.com/images/I/81ANaVZk5LL._AC_UF1000,1000_QL80_.jpg",
    originalPrice: 39,
    salePrice: null,
    rating: 5,
  },
  {
    id: 3,
    title: "Can't Hurt Me",
    url: "https://m.media-amazon.com/images/I/81gTRv2HXrL._AC_UF1000,1000_QL80_.jpg",
    originalPrice: 29,
    salePrice: null,
    rating: 5,
  },
  {
    id: 4,
    title: "Deep Work",
    url: "https://m.media-amazon.com/images/I/91nujEwIpYL._AC_UF1000,1000_QL80_.jpg",
    originalPrice: 44,
    salePrice: 19,
    rating: 4.5,
  },
  {
    id: 5,
    title: "The 10X Rule",
    url: "https://m.media-amazon.com/images/I/71hjq42hvGL._AC_UF1000,1000_QL80_.jpg",
    originalPrice: 32,
    salePrice: null,
    rating: 5,
  },
  {
    id: 6,
    title: "Sell Or Be Sold",
    url: "https://m.media-amazon.com/images/I/616OvChM3RL._AC_UF1000,1000_QL80_.jpg",
    originalPrice: 70,
    salePrice: 12.5,
    rating: 5,
  },
  {
    id: 7,
    title: "Rich Dad Poor Dad",
    url: "https://m.media-amazon.com/images/I/81bsw6fnUiL.jpg",
    originalPrice: 11,
    salePrice: 10,
    rating: 4,
  },
  {
    id: 8,
    title: "Cashflow Quadrant",
    url: "https://m.media-amazon.com/images/I/71+SWQ6xj1L._AC_UF1000,1000_QL80_.jpg",
    originalPrice: 38,
    salePrice: 17.95,
    rating: 4.5,
  },
  {
    id: 9,
    title: "48 Laws of Power Summary",
    url: "https://m.media-amazon.com/images/I/611X8GI7hpL._AC_UF1000,1000_QL80_.jpg",
    originalPrice: 35,
    salePrice: 19.95,
    rating: 4.5,
  },
  {
    id: 10,
    title: "The 5 Second Rule",
    url: "https://m.media-amazon.com/images/I/91wOERyhh7L._UF1000,1000_QL80_.jpg",
    originalPrice: 40,
    salePrice: null,
    rating: 5,
  },
  {
    id: 11,
    title: "How to Win Friends & Influence People",
    url: "https://m.media-amazon.com/images/I/71vK0WVQ4rL._AC_UF1000,1000_QL80_.jpg",
    originalPrice: 30,
    salePrice: 20,
    rating: 5,
  },
  {
    id: 12,
    title: "Mastery",
    url: "https://m.media-amazon.com/images/I/51V3121nmkL._AC_UF1000,1000_QL80_.jpg",
    originalPrice: 30,
    salePrice: 12.95,
    rating: 4.5,
  },
];